function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { IconWrapper } from '../IconWrapper';
export var ThumbUpOutlineIcon = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 19.9999H18C18.83 19.9999 19.54 19.4999 19.84 18.7799L22.86 11.7299C22.95 11.4999 23 11.2599 23 10.9999V8.99994C23 7.89994 22.1 6.99994 21 6.99994H14.69L15.64 2.42994L15.67 2.10994C15.67 1.69994 15.5 1.31994 15.23 1.04994L14.17 -6.10352e-05L7.58 6.58994C7.22 6.94994 7 7.44994 7 7.99994V17.9999C7 19.0999 7.9 19.9999 9 19.9999ZM9 7.99994L13.34 3.65994L12 8.99994H21V10.9999L18 17.9999H9V7.99994ZM1 7.99994H5V19.9999H1V7.99994Z",
    fill: "#222"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  })))));
});
//# sourceMappingURL=ThumbUpOutlineIcon.js.map